import { useEffect, useState } from 'react';
import { Get, Post } from '../utils/RemoteAuthority';

// Where to go once signed in: the page that sent us here (?next=?game=1), else the front page
const nextAddress = () => {
    const next = new URLSearchParams(window.location.search).get('next');
    return next?.startsWith('?') ? `./${next}` : './';
};

// The sign-in page, when the server keeps usernames and passwords itself (its "password" way of signing in, see
// api/identity/password.js): log in, or sign up (with the code the host gave out, when the server asks for one). The
// browser stays signed in after that, so the address can be bookmarked.
function SignIn()
{
    const [signingUp, setSigningUp] = useState(false);
    const [needsCode, setNeedsCode] = useState(false);
    const [fields, setFields] = useState({ login: '', name: '', password: '', code: '' });
    const [error, setError] = useState(null);
    const [busy, setBusy] = useState(false);
    useEffect(() => {
        Get('/auth/password').then(about => setNeedsCode(!!about.signUpCode)).catch(() => {});
    }, []);
    const field = (key) => (e) => setFields({ ...fields, [key]: e.target.value });
    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError(null);
        try {
            const result = await Post(`/auth/password/${signingUp ? 'signup' : 'login'}`, fields);
            if (result.ok)
            {
                window.location.href = nextAddress();
                return;
            }
            setError(result.error);
        } catch {
            setError('The game server is not answering.');
        }
        setBusy(false);
    };
    return <form className="tta-sign-in" onSubmit={submit}>
        <h3>{signingUp ? 'Sign up' : 'Log in'}</h3>
        <label>Username
            <input value={fields.login} onChange={field('login')} autoComplete="username" autoCapitalize="none" required/>
        </label>
        {signingUp && <label>Name others see
            <input value={fields.name} onChange={field('name')} placeholder="(your username)" maxLength={40}/>
        </label>}
        <label>Password
            <input type="password" value={fields.password} onChange={field('password')}
                autoComplete={signingUp ? 'new-password' : 'current-password'} minLength={signingUp ? 8 : undefined} required/>
        </label>
        {signingUp && needsCode && <label>Sign-up code
            <input value={fields.code} onChange={field('code')} autoComplete="off" required/>
        </label>}
        {error && <div className="tta-warning">{error}</div>}
        <div className="tta-sign-in-buttons">
            <button className="tta-button dark" type="submit" disabled={busy}>{signingUp ? 'Sign up' : 'Log in'}</button>
            <button className="tta-link-button" type="button" onClick={() => { setSigningUp(!signingUp); setError(null); }}>
                {signingUp ? 'I have an account: log in' : 'New here? Sign up'}
            </button>
        </div>
    </form>;
}

export default SignIn;
